import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../../lib/api';

export type ShutdownStatus = {
  active: boolean;
  bannerEnabled: boolean;
  controls: {
    registrations: boolean;
    purchases: boolean;
    generations: boolean;
    assistant: boolean;
    uploads: boolean;
    readOnly: boolean;
  };
  dates: {
    firstNoticeAt: string | null;
    coreCutoffAt: string | null;
    downloadEndAt: string | null;
  };
  closureUrl: string;
  contacts: {
    support: string;
    legal: string;
    privacy: string;
  };
};

export const DEFAULT_SHUTDOWN_STATUS: ShutdownStatus = {
  active: false,
  bannerEnabled: false,
  controls: {
    registrations: false,
    purchases: false,
    generations: false,
    assistant: false,
    uploads: false,
    readOnly: false,
  },
  dates: {
    firstNoticeAt: '2026-07-17T00:00:00+03:00',
    coreCutoffAt: '2026-08-17T23:59:00+03:00',
    downloadEndAt: '2026-09-16T23:59:00+03:00',
  },
  closureUrl: '/closure',
  contacts: {
    support: 'sultan@masfufah.com',
    legal: 'legal@masfufah.com',
    privacy: 'privacy@masfufah.com',
  },
};

export const SHUTDOWN_STATUS_QUERY_KEY = ['shutdown-status'] as const;

export const useShutdownStatus = () =>
  useQuery({
    queryKey: SHUTDOWN_STATUS_QUERY_KEY,
    queryFn: () =>
      apiFetch<ShutdownStatus>('/shutdown/status', {
        skipAuth: true,
      }),
    staleTime: 60_000,
    refetchInterval: 60_000,
    retry: false,
  });
